import { render } from "./EmployeeSign.vue?vue&type=template&id=65848f00"
import script from "./EmployeeSign.vue?vue&type=script&lang=js"
export * from "./EmployeeSign.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__